import { useMatch, useSearchParams } from "react-router-dom";
import { SITE_MATCH_PATTERNS } from "@/routes/paths";

const [CONTROL, HEALTH, HEALTH_RECORDS] = SITE_MATCH_PATTERNS;

export function useCurrentSiteId(): number | null {
  const control = useMatch(CONTROL);
  const health = useMatch(HEALTH);
  const healthRecords = useMatch(HEALTH_RECORDS);
  const [searchParams] = useSearchParams();

  const raw =
    control?.params.siteId ??
    health?.params.siteId ??
    healthRecords?.params.siteId ??
    searchParams.get("site");
  if (!raw) return null;
  const id = Number(raw);
  return Number.isFinite(id) ? id : null;
}
